/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useEffect, useState} from 'react'
import {ILayout, LayoutSetup, getLayoutFromLocalStorage} from '../../../../../_metronic/layout/core'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {ColorResult, SketchPicker} from 'react-color'
import {generateToken, getSettings, updateSettings, uploadProfile} from '../core/_requests'
import {useCompanies} from '../../../auth/core/Companies'
import {useAuth} from '../../../auth'
import { toast, ToastContainer } from 'react-toastify';

const DokmeeSettings: React.FC = () => {
  const [tab, setTab] = useState('Sidebar')
  const [config, setConfig] = useState<ILayout>(getLayoutFromLocalStorage())
  const [configLoading, setConfigLoading] = useState<boolean>(false)
  const [resetLoading, setResetLoading] = useState<boolean>(false)
  const [days, setdays] = useState<string>('')
  const [assistantName, setAssitantName] = useState<string>('')
  const [defultEmail, setdefultEmail] = useState<string>('')
  const [defaultKey, setDefautlKey] = useState<string>('')
  const {defaultCompany} = useCompanies()
  const auth: any = useAuth()
  const [socialIcon1, setsocialIcon1] = useState<string>('')
  const [socialIcon2, setsocialIcon2] = useState<string>('')
  const [socialIcon3, setsocialIcon3] = useState<string>('')


  const [initialMessage, setInitialMessage] = useState<string>('')
  const [exitMessage, setExitMessage] = useState<string>('')
  const [infoMessage, setInfoMessage] = useState<string>('')

  const [answers, setAnswers] = useState<string>('')
  const [colorDetails, setColorDetails] = useState({
    displayColorPicker: false,
    color: '#37d67a',
  })

  const [socialColorBg, setsocialColorBg] = useState({
    displayColorPicker: false,
    color: '#37d67a',
  })
  const [socialColorfg, setSocialColorfg] = useState({
    displayColorPicker: false,
    color: '#37d67a',
  })
  const [selectedImage, setSelectedImage]: any = useState(null)
  const [imageUrl, setImageUrl]: any = useState(null)
  const [apiToken, setAPIToken]: any = useState(null)
  const [selectedImageAssistant, setSelectedImageAssistant]: any = useState(null)
  const [imageUrlAssistant, setimageUrlAssistant]: any = useState(null)

  const [code, setCode] = useState(
    `<script>
    const container=document.createElement("div");window.onload=function(){container.id="iframeContainerChatWidget",container.setAttribute("crossorigin","*"),container.style.minHeight="96px",container.style.minWidth="100px",container.style.width="100px",container.style.height="96px",container.style.position="fixed",container.style.bottom="20px",container.style.right="20px",container.style.zIndex="9999";let t=document.createElement("iframe");t.src="https://chat.dokmee.com/widget/?company=${defaultCompany?.company_id}",t.setAttribute("crossorigin","*"),t.style.width="100%",t.style.height="100%",t.style.border="none",t.style.backgroundColor="transparent",container.appendChild(t),document.body.appendChild(container),window.addEventListener("message",t=>{let e=document.getElementById("iframeContainerChatWidget");e&&t.data.hasOwnProperty("type")&&(t.data.type?e.style.cssText+="height:96px;width:100px":e.style.cssText+="height:800px;width:450px")})};
    </script>`
  )

  const handleCopyClick = (event: any) => {
    event.preventDefault()
    navigator.clipboard.writeText(code)
  }

  const copyAPIDataMessage = (message: any) => {
    toast.success(message + " copied sucessfully.");
    if(message=='Company ID'){
      navigator.clipboard.writeText(defaultCompany?.company_id ?? '');
    }else{
      navigator.clipboard.writeText(apiToken ?? '');

    }
  }


  const generateNewToken = async() => {
     await generateToken(defaultCompany?.company_id ?? '');
     window.location.reload();

  }

  const handleOpenNewTab = () => {
    const domainUrl = window.location.origin + '/widget/?company=' + defaultCompany?.company_id + '&demo=true'
    window.open(domainUrl, '_blank')
  }

  const updateConfig = async () => {
    setConfigLoading(true)
    try {
      var logodata
      if (selectedImage) {
        logodata = await uploadProfile(selectedImage)
      }
      var assistantLogo
      if (selectedImageAssistant) {
        assistantLogo = await uploadProfile(selectedImageAssistant)
      }
      await updateSettings(
        {
          logo: selectedImage ? logodata?.data.url : imageUrl,
          assistantLogo: selectedImageAssistant ? assistantLogo?.data.url : imageUrlAssistant,
          name: assistantName,
          color: colorDetails.color,
          days: days,
          answers: answers,
          defaultEmail: defultEmail,
          apiKey: defaultKey,
          initialMessage: initialMessage,
          infoMessage: infoMessage,
          exitMessage: exitMessage,
          socialIcon1: socialIcon1,
          socialIcon2: socialIcon2,
          socialIcon3: socialIcon3,
          socialColorFg : socialColorfg.color,
          socialColorBg : socialColorBg.color,
          token: apiToken
        },
        defaultCompany?.company_id ?? ''
      )
      LayoutSetup.setConfig(config)
      window.location.reload()
    } catch (error) {
      setConfig(getLayoutFromLocalStorage())
      setConfigLoading(false)
    }
  }

  const reset = () => {
    setResetLoading(true)
    setTimeout(() => {
      setConfig(getLayoutFromLocalStorage())
      setResetLoading(false)
    }, 1000)
  }

  const handleClick = () => {
    setColorDetails({
      displayColorPicker: !colorDetails.displayColorPicker,
      color: colorDetails.color,
    })
  }

  const handleClose = () => {
    setColorDetails({displayColorPicker: false, color: colorDetails.color})
  }


  const handleClickBg = () => {
    setsocialColorBg({
      displayColorPicker: !socialColorBg.displayColorPicker,
      color: socialColorBg.color,
    })
  }

  const handleCloseBg = () => {
    setsocialColorBg({displayColorPicker: false, color: socialColorBg.color})
  }


  const handleClickfg = () => {
    setSocialColorfg({
      displayColorPicker: !socialColorfg.displayColorPicker,
      color: socialColorfg.color,
    })
  }

  const handleClosefg = () => {
    setSocialColorfg({displayColorPicker: false, color: socialColorfg.color})
  }
  const getSettingsData = async () => {
    var data = await getSettings(defaultCompany?.company_id ?? '')
    console.log(data)
    setColorDetails({displayColorPicker: false, color: data.color!})
    if (data.logo && data.logo != '') {
      setImageUrl(data.logo)
    }
    if (data.assistantLogo && data.assistantLogo != '') {
      setimageUrlAssistant(data.assistantLogo)
    }
    setAssitantName(data.name)
    setdays(data.days)
    setAnswers(data.answers)
    setdefultEmail(data.defaultEmail)
    setDefautlKey(data.apiKey)
    setInitialMessage(data.initialMessage)
    setInfoMessage(data.infoMessage)
    setExitMessage(data.exitMessage)
    setsocialIcon1(data.socialIcon1)
    setsocialIcon2(data.socialIcon2)
    setsocialIcon3(data.socialIcon3)
    setsocialColorBg({displayColorPicker: false, color: data.socialColorBg!})
    setSocialColorfg({displayColorPicker: false, color: data.socialColorFg!})
    setAPIToken(data.token);

  }

  const handleChange = (color: ColorResult) => {
    setColorDetails({
      displayColorPicker: colorDetails.displayColorPicker,
      color: color.hex.toString(),
    })
  }

  const handleChangebg = (color: ColorResult) => {
    setsocialColorBg({
      displayColorPicker: socialColorBg.displayColorPicker,
      color: color.hex.toString(),
    })
  }

  const handleChangefg = (color: ColorResult) => {
    setSocialColorfg({
      displayColorPicker: socialColorfg.displayColorPicker,
      color: color.hex.toString(),
    })
  }

  useEffect(() => {
    if (selectedImage) {
      setImageUrl(URL.createObjectURL(selectedImage))
    }
    if (selectedImageAssistant) {
      setimageUrlAssistant(URL.createObjectURL(selectedImageAssistant))
    }
  }, [selectedImage, selectedImageAssistant])

  useEffect(() => {
    getSettingsData()
  }, [])

  const inputStyle = {
    position: 'absolute' as 'absolute',
    opacity: 0,
    height: '100%',
    right: 0,
    top: 0,
  }

  const styles = {
    default: {
      color: {
        width: '36px',
        height: '14px',
        borderRadius: '2px',
        background: colorDetails.color,
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer',
      },
      popover: {
        position: 'fixed' as 'fixed',
        zIndex: '2',
        top: '130px',
        right: '100px',
        bottom: '0px',
        left: '80',
      },
      cover: {
        position: 'fixed' as 'fixed',
        top: '40px',
        right: '100px',
        bottom: '0px',
        left: '300px',
      },
    },
  }

  const stylebg = {
    default: {
      color: {
        width: '36px',
        height: '14px',
        borderRadius: '2px',
        background: socialColorBg.color,
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer',
      },
      popover: {
        position: 'fixed' as 'fixed',
        zIndex: '2',
        top: '130px',
        right: '100px',
        bottom: '0px',
        left: '80',
      },
      cover: {
        position: 'fixed' as 'fixed',
        top: '40px',
        right: '100px',
        bottom: '0px',
        left: '300px',
      },
    },
  }

  const stylesfg = {
    default: {
      color: {
        width: '36px',
        height: '14px',
        borderRadius: '2px',
        background: socialColorfg.color,
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer',
      },
      popover: {
        position: 'fixed' as 'fixed',
        zIndex: '2',
        top: '130px',
        right: '100px',
        bottom: '0px',
        left: '80',
      },
      cover: {
        position: 'fixed' as 'fixed',
        top: '40px',
        right: '100px',
        bottom: '0px',
        left: '300px',
      },
    },
  }

  return (
    <>
      <div className='card card-custom'>
        <div className='card-header card-header-stretch overflow-auto'>
          <ul
            className='nav nav-stretch nav-line-tabs
            fw-bold
            border-transparent
            flex-nowrap
          '
            role='tablist'
          >
            <li className='nav-item'>
              <a
                className={clsx(`nav-link cursor-pointer`, {active: tab === 'Sidebar'})}
                onClick={() => setTab('Sidebar')}
                role='tab'
              >
                General
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={clsx(`nav-link cursor-pointer`, {active: tab === 'Chat Messages'})}
                onClick={() => setTab('Chat Messages')}
                role='tab'
              >
                Chat Messages
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={clsx(`nav-link cursor-pointer`, {active: tab === 'Chat Widget'})}
                onClick={() => setTab('Chat Widget')}
                role='tab'
              >
                Chat Widget
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={clsx(`nav-link cursor-pointer`, {active: tab === 'Social Icons'})}
                onClick={() => setTab('Social Icons')}
                role='tab'
              >
                Social Icons
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={clsx(`nav-link cursor-pointer`, {active: tab === 'Toolbar'})}
                onClick={() => setTab('Toolbar')}
                role='tab'
              >
                Email
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={clsx(`nav-link cursor-pointer`, {active: tab === 'apitokens'})}
                onClick={() => setTab('apitokens')}
                role='tab'
              >
                API Details 
              </a>
            </li>

            {auth?.currentUser?.role == 'Super Admin' && (
              <li className='nav-item'>
                <a
                  className={clsx(`nav-link cursor-pointer`, {active: tab === 'ChatGPT'})}
                  onClick={() => setTab('ChatGPT')}
                  role='tab'
                >
                  ChatGPT Key
                </a>
              </li>
            )}
          </ul>
        </div>

        <form className='form'>
          <div className='card-body'>
            <div className='tab-content pt-3'>
              <div className={clsx('tab-pane', {active: tab === 'Sidebar'})}>
                <div className='form-group d-flex flex-stack'>
                  <div className='d-flex flex-column'>
                    <h4 className='fw-bold text-dark'>Widget Logo </h4>
                    <div className='fs-7 fw-semibold text-muted'>Update your chat widget logo</div>
                  </div>

                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                      <div
                        className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                      >
                        {imageUrl && (
                          <>
                            <img src={imageUrl} height='20PX' className='me-5' />
                          </>
                        )}
                        <div className='btn btn-sm btn-primary me-2 position-relative overflow-hidden '>
                          Upload
                          <input
                            onChange={(e: any) => setSelectedImage(e.target.files[0])}
                            style={inputStyle}
                            accept='image/*'
                            type='file'
                            id='select-image'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='separator separator-dashed my-6'></div>
                <div className='form-group d-flex flex-stack'>
                  <div className='d-flex flex-column'>
                    <h4 className='fw-bold text-dark'>Assistant Logo </h4>
                    <div className='fs-7 fw-semibold text-muted'>Update your Assistant logo</div>
                  </div>

                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                      <div
                        className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                      >
                        {imageUrlAssistant && (
                          <>
                            <img src={imageUrlAssistant} height='20PX' className='me-5' />
                          </>
                        )}
                        <div className='btn btn-sm btn-primary me-2 position-relative overflow-hidden '>
                          Upload
                          <input
                            onChange={(e: any) => setSelectedImageAssistant(e.target.files[0])}
                            style={inputStyle}
                            accept='image/*'
                            type='file'
                            id='select-image-assistant'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='separator separator-dashed my-6'></div>
                <div className='form-group d-flex flex-stack'>
                  <div className='d-flex flex-column'>
                    <h4 className='fw-bold text-dark'>Widget Primary Color</h4>
                    <div className='fs-7 fw-semibold text-muted'>Change your chat widget color</div>
                  </div>

                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                      <div
                        className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                      >
                        <div style={styles.default.swatch} onClick={handleClick}>
                          <div style={styles.default.color} />
                        </div>
                        {colorDetails.displayColorPicker ? (
                          <div style={styles.default.popover}>
                            <div style={styles.default.cover} onClick={handleClose} />
                            <SketchPicker
                              color={colorDetails.color}
                              onChange={(color) => handleChange(color)}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className='separator separator-dashed my-6'></div>

                <div className='form-group d-flex flex-stack'>
                  <div className='d-flex flex-column'>
                    <h4 className='fw-bold text-dark'>Chat Assistant Name</h4>
                    <div className='fs-7 fw-semibold text-muted'>
                      Name which will be visible while chatting
                    </div>
                  </div>
                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                      <div
                        className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                      >
                        <input
                          type='text'
                          data-kt-user-table-filter='days'
                          className='form-control form-control-solid w-150px ps-5'
                          placeholder='Name'
                          value={assistantName}
                          onChange={(e) => setAssitantName(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='separator separator-dashed my-6'></div>

                <div className='form-group d-flex flex-stack'>
                  <div className='d-flex flex-column'>
                    <h4 className='fw-bold text-dark'>Chat Deletion Duration</h4>
                    <div className='fs-7 fw-semibold text-muted'>
                      Number of days to automatic chat delete
                    </div>
                  </div>
                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                      <div
                        className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                      >
                        <input
                          type='text'
                          data-kt-user-table-filter='days'
                          className='form-control form-control-solid w-80px ps-5'
                          placeholder='Days'
                          value={days}
                          onChange={(e) => setdays(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='separator separator-dashed my-6'></div>

                {/* <div className='form-group d-flex flex-stack'>
                  <div className='d-flex flex-column'>
                    <h4 className='fw-bold text-dark'>Max Response</h4>
                    <div className='fs-7 fw-semibold text-muted'>
                      Max number of answers
                    </div>
                  </div>

                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                      <div
                        className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                      >
                        <input
                          type='text'
                          data-kt-user-table-filter='days'
                          className='form-control form-control-solid w-80px ps-5'
                          placeholder='Max'
                          value={answers}
                          onChange={(e) => setAnswers(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className='mb-5'></div>
              </div>

              <div className={clsx('tab-pane', {active: tab === 'Chat Messages'})}>
                <div className='form-group d-flex flex-stack'>
                  <div className='me-5'>
                    <h4 className='fw-bold text-dark'>Initial Greeting </h4>
                    <div className='fs-7 fw-semibold text-muted'>
                      Initial message for your assistant
                    </div>
                  </div>
                  <textarea
                    className='form-control form-control-solid '
                    rows={2}
                    style={{color: 'black'}}
                    value={initialMessage}
                    onChange={(e) => setInitialMessage(e.target.value)}
                  ></textarea>
                </div>

                <div className='separator separator-dashed my-6'></div>
                <div className='form-group d-flex flex-stack'>
                  <div className='me-5'>
                    <h4 className='fw-bold text-dark'>Ending Message </h4>
                    <div className='fs-7 fw-semibold text-muted'>Message while ending chat</div>
                  </div>
                  <textarea
                    className='form-control form-control-solid '
                    rows={2}
                    style={{color: 'black'}}
                    value={exitMessage}
                    onChange={(e) => setExitMessage(e.target.value)}
                  ></textarea>
                </div>

                <div className='separator separator-dashed my-6'></div>
                <div className='form-group d-flex flex-stack'>
                  <div className='me-5'>
                    <h4 className='fw-bold text-dark'>Info Message </h4>
                    <div className='fs-7 fw-semibold text-muted'>
                      Message in case of unknown question
                    </div>
                  </div>
                  <textarea
                    className='form-control form-control-solid '
                    rows={2}
                    style={{color: 'black'}}
                    value={infoMessage}
                    onChange={(e) => setInfoMessage(e.target.value)}
                  ></textarea>
                </div>
              </div>

              <div className={clsx('tab-pane', {active: tab === 'Chat Widget'})}>
                <div className='form-group d-flex flex-stack'>
                  <textarea
                    className='form-control form-control-solid mb-8'
                    rows={16}
                    style={{color: 'black'}}
                    value={code}
                    readOnly
                  ></textarea>
                  <button
                    className='btn btn-primary btn-sm'
                    style={{position: 'absolute', top: 120, right: 40}}
                    onClick={handleCopyClick}
                  >
                    <KTSVG path='/media/svg/customicons/copy.svg' className='svg-icon' />
                    Copy
                  </button>
                  <button
                    className='btn btn-primary btn-sm'
                    style={{position: 'absolute', top: 120, right: 200}}
                    onClick={handleOpenNewTab}
                  >
                    <KTSVG path='/media/svg/customicons/copy.svg' className='svg-icon' />
                    Test Widget
                  </button>
                </div>
                <div className='separator separator-dashed my-6'></div>
              </div>
              <div className={clsx('tab-pane', {active: tab === 'Social Icons'})}>
                <div className='form-group d-flex flex-stack'>
                  <div className='d-flex flex-column'>
                    <h4 className='fw-bold text-dark'>Social Url 1</h4>
                    <div className='fs-7 fw-semibold text-muted'>
                    Enter your link we will automatically add icon
                    </div>
                  </div>
                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                      <div
                        className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                      >
                        <input
                          type='text'
                          data-kt-user-table-filter='email'
                          className='form-control form-control-solid w-650px ps-5'
                          placeholder='Social url here'
                          value={socialIcon1}
                          onChange={(e) => setsocialIcon1(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>


                <div className='form-group d-flex flex-stack mt-10'>
                  <div className='d-flex flex-column'>
                    <h4 className='fw-bold text-dark'>Social Url 2</h4>
                    <div className='fs-7 fw-semibold text-muted'>
                    Enter your link we will automatically add icon
                    </div>
                  </div>
                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                      <div
                        className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                      >
                        <input
                          type='text'
                          data-kt-user-table-filter='email'
                          className='form-control form-control-solid w-650px ps-5'
                          placeholder='Social url here'
                          value={socialIcon2}
                          onChange={(e) => setsocialIcon2(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='form-group d-flex flex-stack mt-10'>
                  <div className='d-flex flex-column'>
                    <h4 className='fw-bold text-dark'>Social Url 3</h4>
                    <div className='fs-7 fw-semibold text-muted'>
                      Enter your link we will automatically add icon
                    </div>
                  </div>
                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                      <div
                        className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                      >
                        <input
                          type='text'
                          data-kt-user-table-filter='email'
                          className='form-control form-control-solid w-650px ps-5'
                          placeholder='Social url here'
                          value={socialIcon3}
                          onChange={(e) => setsocialIcon3(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='form-group d-flex flex-stack mt-10'>
                  <div className='d-flex flex-column'>
                    <h4 className='fw-bold text-dark'>Social Icon Background </h4>
                    <div className='fs-7 fw-semibold text-muted'>Change your social icon background color</div>
                  </div>

                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                      <div
                        className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                      >
                        <div style={stylebg.default.swatch} onClick={handleClickBg}>
                          <div style={stylebg.default.color} />
                        </div>
                        {socialColorBg.displayColorPicker ? (
                          <div style={stylebg.default.popover}>
                            <div style={stylebg.default.cover} onClick={handleCloseBg} />
                            <SketchPicker
                              color={socialColorBg.color}
                              onChange={(color) => handleChangebg(color)}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>

                <div className='form-group d-flex flex-stack mt-10'>
                  <div className='d-flex flex-column'>
                    <h4 className='fw-bold text-dark'>Social Icon Foreground </h4>
                    <div className='fs-7 fw-semibold text-muted'>Change your social icon foreground color</div>
                  </div>

                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                      <div
                        className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                      >
                        <div style={stylesfg.default.swatch} onClick={handleClickfg}>
                          <div style={stylesfg.default.color} />
                        </div>
                        {socialColorfg.displayColorPicker ? (
                          <div style={stylesfg.default.popover}>
                            <div style={stylesfg.default.cover} onClick={handleClosefg} />
                            <SketchPicker
                              color={socialColorfg.color}
                              onChange={(color) => handleChangefg(color)}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className='separator separator-dashed my-6'></div>
              </div>

              


              <div className={clsx('tab-pane', {active: tab === 'apitokens'})}>
                <div className='form-group d-flex flex-stack'>
                  <div className='d-flex flex-column'>
                    <h4 className='fw-bold text-dark'>Company ID</h4>
                    <div className='fs-7 fw-semibold text-muted'>
                      Company ID used to fetch data for your company
                    </div>
                  </div>
                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                      <div
                        className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                      >
                        <input
                          type='text'
                          data-kt-user-table-filter='email'
                          className='form-control form-control-solid w-250px ps-5 me-2'
                          placeholder='Your Company ID'
                          value={defaultCompany?.company_id}

                        />
                         <div
                          className='custom-icon-button'
                          onClick={()=>{copyAPIDataMessage("Company ID")}}
                        >
                          <KTSVG path='/media/svg/customicons/copy.svg' className='svg-icon' />

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='form-group d-flex flex-stack mt-10'>
                  <div className='d-flex flex-column'>
                    <h4 className='fw-bold text-dark'>API Token</h4>
                    <div className='fs-7 fw-semibold text-muted'>
                      Your API token will be used to make API request
                    </div>
                  </div>
                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                      <div
                        className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                      >
                        <input
                          type='text'
                          data-kt-user-table-filter='email'
                          className='form-control form-control-solid w-250px ps-5 me-2'
                          placeholder='Your API Key'
                          value={apiToken}

                        />
                         <div
                          className='custom-icon-button me-2'
                          onClick={()=>{copyAPIDataMessage("API Token")}}
                        >
                          <KTSVG path='/media/svg/customicons/copy.svg' className='svg-icon' />

                        </div>

                        <div
                          className='custom-icon-button'
                          onClick={()=>{generateNewToken()}}
                        >
                          <KTSVG path='/media/svg/customicons/refresh.svg' className='svg-icon' />

                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
                <div className='separator separator-dashed my-6'></div>
              </div>

              

              <div className={clsx('tab-pane', {active: tab === 'Toolbar'})}>
                <div className='form-group d-flex flex-stack'>
                  <div className='d-flex flex-column'>
                    <h4 className='fw-bold text-dark'>Admin Email</h4>
                    <div className='fs-7 fw-semibold text-muted'>
                      Default Email for Chat Receipts
                    </div>
                  </div>
                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                      <div
                        className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                      >
                        <input
                          type='text'
                          data-kt-user-table-filter='email'
                          className='form-control form-control-solid w-250px ps-5'
                          placeholder='Email here'
                          value={defultEmail}
                          onChange={(e) => setdefultEmail(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='separator separator-dashed my-6'></div>
              </div>

              <div className={clsx('tab-pane', {active: tab === 'ChatGPT'})}>
                <div className='form-group d-flex flex-stack'>
                  <div className='d-flex flex-column'>
                    <h4 className='fw-bold text-dark'>API Key</h4>
                    <div className='fs-7 fw-semibold text-muted'>ChatGPT API Key</div>
                  </div>
                  <div className='d-flex justify-content-end'>
                    <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                      <div
                        className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                      >
                        <input
                          type='text'
                          data-kt-user-table-filter='key'
                          className='form-control form-control-solid w-400px ps-5'
                          placeholder='API Key here'
                          value={defaultKey}
                          onChange={(e) => setDefautlKey(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='separator separator-dashed my-6'></div>
              </div>
            </div>

            <div className=''>
              <div className=' d-flex flex-row-reverse'>
                <div className='pt-10 px-0 me-0 mr-0 mx-0'>
                  {' '}
                  <button type='button' onClick={updateConfig} className='btn btn-primary me-2'>
                    {!configLoading && <span className='indicator-label'>Save Settings</span>}
                    {configLoading && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Please wait...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                </div>

                {/* <button
                    type='button'
                    id='kt_layout_builder_reset'
                    className='btn btn-active-light btn-color-muted'
                    onClick={reset}
                  >
                    {!resetLoading && <span className='indicator-label'>Reset</span>}
                    {resetLoading && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Please wait...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button> */}
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

export {DokmeeSettings}
